import { createFileRoute } from '@tanstack/react-router';
import {
  SetupOverviewMap,
  usePipelineStatus,
  useVisibleSteps,
} from '@/features/analysis-setup';

export const Route = createFileRoute('/analysis-setup/')({
  component: AnalysisSetupIndex,
});

function AnalysisSetupIndex() {
  const {
    statuses,
    vendor,
    vendorKnown,
    unavailable,
    retryUnavailable,
    retryable,
    retrying,
  } = usePipelineStatus();
  // Same hook the step intros count with, so the map, the strip and the
  // "Step N of M" caption cannot disagree about which steps exist here.
  const { hiddenSteps } = useVisibleSteps();

  return (
    <SetupOverviewMap
      statuses={statuses}
      hiddenSteps={hiddenSteps}
      vendor={vendorKnown ? vendor : undefined}
      unavailable={unavailable}
      onRetry={retryable ? retryUnavailable : undefined}
      retrying={retrying}
    />
  );
}
